<template>
  <router-view />
</template>
<script>
export default { name: 'Tags' }
</script>
